var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**ONBOARDING**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "my529-Success-Screen",
    transform: "translate(-684, -174)",
    fill: "#14BC21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.825917,224.913903 L739.055569,199.68425 L736.263889,196.892569 L713.825917,219.330542 L702.58425,208.088875 L699.792569,210.880556 L713.825917,224.913903 Z M719.512819,245 C714.603958,245 709.98863,244.068454 705.666833,242.205361 C701.345694,240.342269 697.586639,237.81388 694.389667,234.620194 C691.192694,231.426509 688.662005,227.670741 686.797597,223.352889 C684.932532,219.035694 684,214.422338 684,209.512819 C684,204.603958 684.931546,199.98863 686.794639,195.666833 C688.657731,191.345694 691.18612,187.586639 694.379806,184.389667 C697.573491,181.192694 701.329259,178.662005 705.647111,176.797597 C709.964306,174.932532 714.577662,174 719.487181,174 C724.396042,174 729.01137,174.931546 733.333167,176.794639 C737.654306,178.657731 741.413361,181.18612 744.610333,184.379806 C747.807306,187.573491 750.337995,191.329259 752.202403,195.647111 C754.067468,199.964306 755,204.577662 755,209.487181 C755,214.396042 754.068454,219.01137 752.205361,223.333167 C750.342269,227.654306 747.81388,231.413361 744.620194,234.610333 C741.426509,237.807306 737.670741,240.337995 733.352889,242.202403 C729.035694,244.067468 724.422338,245 719.512819,245 Z M719.5,241.055556 C728.309259,241.055556 735.770833,237.998611 741.884722,231.884722 C747.998611,225.770833 751.055556,218.309259 751.055556,209.5 C751.055556,200.690741 747.998611,193.229167 741.884722,187.115278 C735.770833,181.001389 728.309259,177.944444 719.5,177.944444 C710.690741,177.944444 703.229167,181.001389 697.115278,187.115278 C691.001389,193.229167 687.944444,200.690741 687.944444,209.5 C687.944444,218.309259 691.001389,225.770833 697.115278,231.884722 C703.229167,237.998611 710.690741,241.055556 719.5,241.055556 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic_success.699a74d7fd1dd444853c11392a1cd098.svg";
export { ForwardRef as ReactComponent };